import React, { useEffect, useState } from "react";
import "./Resume.css";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import resumePDF from "../../assets/Praveen_Kumar Resume.pdf";

import { doc, updateDoc, increment, getDoc } from "firebase/firestore";
import { db } from "../../firebase";

import VisitorTracker from "../../components/VisitorTracker";

const Resume = () => {

  const navigate = useNavigate();
  const [downloads,setDownloads] = useState(0);

  useEffect(()=>{

    AOS.init({ duration:900, once:true });

    const fetchDownloads = async () => {

      const docRef = doc(db,"analytics","resumeDownloads");
      const docSnap = await getDoc(docRef);

      if(docSnap.exists()){
        setDownloads(docSnap.data().count);
      }

    };

    fetchDownloads();

  },[]);

  const handleDownload = async () => {

    const docRef = doc(db,"analytics","resumeDownloads");

    await updateDoc(docRef,{
      count: increment(1)
    });

    setDownloads(prev => prev + 1);

    const link = document.createElement("a");
    link.href = resumePDF;
    link.download = "Praveen_Kumar_Resume.pdf";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  };

  const handlePrint = () => {
    window.open(resumePDF,"_blank");
  };

  return (

    <div className="resume-page">

      {/* HEADER */}

      <header className="resume-header">

        <div>

          <h1 className="resume-name">
            Praveen Kumar B
          </h1>

          <p className="resume-role">
            Software Engineer
          </p>

          <p className="download-count">
            Resume Downloads : {downloads}
          </p>

        </div>

        <div className="resume-actions">

          <button className="btn outline" onClick={handleDownload}>
            ⬇ Download
          </button>

          <button className="btn outline" onClick={handlePrint}>
            🖨 Print
          </button>

          <button className="btn primary" onClick={()=>navigate("/contact")}>
            📞 Contact
          </button>

        </div>

      </header>

      {/* GRID */}

      <div className="resume-grid">

        {/* LEFT */}

        <aside className="resume-left">

          <div className="card">

            <h3>Contact</h3>

            <p><b>Email</b><br/>
            praveenkumarbofficial@gmail.com</p>

            <p><b>Phone</b><br/>
            +91 6369704548</p>

            <p><b>LinkedIn</b><br/>
            <a href="https://linkedin.com/in/praveenkumarbofficial" target="_blank" rel="noreferrer">
            linkedin.com/in/praveenkumarbofficial
            </a></p>

            <p><b>Portfolio</b><br/>
            <a href="https://praveen-kumar-b.web.app" target="_blank" rel="noreferrer">
            praveen-kumar-b.web.app
            </a></p>

            <p><b>GitHub</b><br/>
            <a href="https://github.com/praveenkumar-king" target="_blank" rel="noreferrer">
            github.com/praveenkumar-king
            </a></p>

          </div>

          <div className="card">

            <h3>Technical Skills</h3>

            <ul>
              <li><b>Languages:</b> Java, JavaScript</li>
              <li><b>Frameworks:</b> Spring Boot, React</li>
              <li><b>Databases:</b> MySQL, MongoDB</li>
              <li><b>Cloud:</b> AWS, Firebase</li>
              <li><b>Tools:</b> GitHub, Postman, VS Code, IntelliJ</li>
              <li><b>Core Concepts:</b> OOPS, Data Structures, DBMS</li>
            </ul>

          </div>

          <div className="card">

            <h3>Soft Skills</h3>

            <ul>
              <li>Problem Solving</li>
              <li>Communication</li>
              <li>Team Collaboration</li>
            </ul>

          </div>

          {/* QR CODE */}

          <div className="card qr-card">

            <h3>Resume QR</h3>

            <img
            src="https://api.qrserver.com/v1/create-qr-code/?data=https://drive.google.com/file/d/1Otkz-oRKibIol-UC4YnGLS66Z05BTiQ9/view?usp=sharing&size=200x200"
            alt="resume qr"
            />

            <p>Scan to view resume</p>

          </div>

        </aside>

        {/* RIGHT */}

        <section className="resume-right">

          <div className="card">

            <h2>Objective</h2>

            <p>
            Entry-level Software Engineer with strong foundations in Java,
            Spring Boot, React, and MySQL. Passionate about building scalable
            applications and continuously improving modern software engineering practices.
            </p>

          </div>

          <div className="card">

            <h2>Education</h2>

            <ul>

              <li>
              <b>B.E Computer Science Engineering</b><br/>
              Dr. Mahalingam College of Engineering and Technology (2023–2026)<br/>
              CGPA: 6.9
              </li>

              <li>
              <b>Diploma – Computer Engineering</b><br/>
              Nachimuthu Polytechnic College (2020–2023)<br/>
              Percentage: 72%
              </li>

            </ul>

          </div>

          <div className="card">

            <h2>Projects</h2>

            <h4>Notes App – Secure Notes Management Web Application</h4>

            <ul>
              <li>Developed a secure full-stack notes application using React, Node.js and MongoDB.</li>
              <li>Implemented JWT authentication and email based password reset.</li>
              <li>Deployed using Netlify and Render with Cloudflare protection.</li>
            </ul>

            <h4>OpsMind AI – Context Aware Knowledge Assistant</h4>

            <ul>
              <li>Built AI powered document search assistant using RAG architecture.</li>
              <li>Integrated MongoDB Atlas vector search for semantic search.</li>
              <li>Developed scalable backend APIs using Node.js and Express.</li>
            </ul>

            <h4>AdVantage Gen – AI Marketing Creative Generator</h4>

            <ul>
              <li>Developed AI SaaS platform generating marketing posters and captions.</li>
              <li>Built responsive UI using React.</li>
              <li>Designed backend APIs with Node.js and MongoDB.</li>
            </ul>

          </div>

        </section>

      </div>

      {/* VISITOR ANALYTICS */}

      <VisitorTracker/>

    </div>

  );

};

export default Resume;